const GETAUDIT_START = "GETAUDIT_START";
const GETAUDIT_SUCC = "GETAUDIT_SUCC";
const GETAUDIT_FAIL = "GETAUDIT_FAIL";

const initialState = {
    data: {},
    isfetching: false,
    fail: false,
}

export default function (state = initialState, action) {
    switch (action.type) {
        case GETAUDIT_START: {
            return {
                ...state,
                isfetching: true,
            }
        }
        case GETAUDIT_SUCC: {
            return {
                ...state,
                isfetching: false,
                data: action.data,
            }
        }
        case GETAUDIT_FAIL: {
            return {
                ...state,
                error: action.error,
                isfetching: false,
                fail: true,
            }
        }
        default: return state
    }
}
